import { WORKSPACE_USER_FRAGMENT } from 'features/globalSetup/api/fragments/workspaceUser'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_WORKSPACE_USER: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${WORKSPACE_USER_FRAGMENT}
  ${ERROR_FRAGMENT}

  mutation updateWorkspaceUser($input: UpdatePublisherByWorkspaceOwnerInput!) {
    updatePublisherByWorkspaceOwner(input: $input) {
      user {
        ...WorkspaceUserFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
